module.exports = __webpack_public_path__ + "static/media/kawhi-placeholder.66890d31.png";